import { atom } from "recoil";
import { IEmployeeBilingual, SelectedRowsToDelete } from "../types";

export const addStateEmployeeBilingual = atom({
  key: "addStateEmployeeBilingual",
  default: false,
});
export const editStateEmployeeBilingual = atom({
  key: "editStateEmployeeBilingual",
  default: false,
});

export const selectedRowsStateEmployeeBilingual = atom<SelectedRowsToDelete>({
  key: "selectedRowsStateEmployeeBilingual",
  default: [],
});

export const editRowIdEmployeeBilingual = atom({
  key: "editRowIdEmployeeBilingual",
  default: [],
});

export const savingEmployeeBilingual = atom({
  key: "savingEmployeeBilingual",
  default: false,
});

export const selectedRowsBilingualToDelete = atom<
  SelectedRowsToDelete | undefined
>({
  key: "selectedRowsDomainToDelete",
  default: undefined,
});

export const rowForEditEmployeeBilingual = atom<IEmployeeBilingual | undefined>(
  {
    key: "rowForEditEmaployeeBilingual",
    default: undefined,
  }
);
